"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SplitProvider_1 = require("./SplitProvider");
/**
 * Component that will receive a split prop, connect on SplitContext and return treatment when SDK is ready.
 * @param props
 *
 * @example
 *
 * <Split name={'my-split'}>
 *   {(value: TreatmentWithConfig) => value.treatment === 'on' ? this.renderComponent() : null}
 * </Split>
 */
var Split = function (_a) {
    var name = _a.name, children = _a.children, attributes = _a.attributes;
    var _b = react_1.useContext(SplitProvider_1.SplitContext), client = _b.client, isReady = _b.isReady, lastUpdate = _b.lastUpdate;
    return children(client && isReady
        ? name instanceof Array
            ? client.getTreatmentsWithConfig(name, attributes)
            : client.getTreatmentWithConfig(name, attributes)
        : SplitProvider_1.defaultTreatment, client, lastUpdate);
};
Split.defaultProps = {
    attributes: null,
    name: '',
};
exports.default = Split;
//# sourceMappingURL=Split.js.map